import { render, staticRenderFns } from "./EditarCancha.vue?vue&type=template&id=52cf5de8"
import script from "./EditarCancha.vue?vue&type=script&lang=js"
export * from "./EditarCancha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports